export default __webpack_public_path__ + "static/media/Upper_Trapezius.55722956.svg";